// The Reports feature (collections sprint, Instance D). registry.js imports the page and its
// sidebar icon from here; other pages import ExportButton directly.
import React from "react";

export { default } from "./ReportsPage";
export { default as ExportButton } from "./ExportButton";

export const reportsIcon = (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M3 3v18h18" />
    <rect x="7" y="12" width="3" height="6" />
    <rect x="12" y="8" width="3" height="10" />
    <rect x="17" y="5" width="3" height="13" />
  </svg>
);
